import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { CsvDownloadService } from '../../service/csv-download.service';
import { CsvExport } from '../../../../config/globals/csvExport.global';
import { MaklerPaketStatus } from "../../service/Model/MaklerPaketStatus";

@Component({
  selector: 'app-package-table',
  templateUrl: './package-table.component.html',
  styleUrls: ['./package-table.component.scss']
})
export class PackageTableComponent implements OnChanges {

  @Input()
  maklerPaketStatusInput: MaklerPaketStatus;

  @Output()
  maklerPaketStatusEventEmitter: EventEmitter<MaklerPaketStatus> = new EventEmitter<MaklerPaketStatus>();

  labelAnzeigeTableHeader: any[] = [
    {id: 1, label: 'Lieferdatum'},
    {id: 2, label: 'Dateiname'},
    // {id: 3, label: 'Branche'},
    {id: 4, label: 'Verarbeitungsstatus'}
  ];

  public paketStatuses: MaklerPaketStatus[] = [];
  public currentPackageSite: number = 0;
  public displayedPackages: number;

  constructor(
    private csvService: CsvDownloadService,
    private csvExport: CsvExport,
    ) {
  }

  ngOnChanges() {
    if(this.paketStatuses!=undefined&&this.paketStatuses!=null) {
      this.loadFirstTenElements();
    }
  }

  private changeDisplayedPackageSite() {
      console.log("changeDisplayedPackageSite befor" + this.maklerPaketStatusInput);
      this.paketStatuses.push(this.maklerPaketStatusInput);
      console.log("changeDisplayedPackageSite after" + this.paketStatuses[0]);
  }

  private loadFirstTenElements(): void {
    this.currentPackageSite = 0;
    this.displayedPackages = 10;
    this.changeDisplayedPackageSite();
  }

  setCurrentPackageSite(site: number) {
    this.currentPackageSite = site;
    this.changeDisplayedPackageSite();
  }

  setNumberOfDisplayedPackages(numberDisplayed: number) {
    this.displayedPackages = numberDisplayed;
    this.changeDisplayedPackageSite();
  }

  showDetail(paketStatus: MaklerPaketStatus) {
    console.log("showDetail befor" + paketStatus);
    this.paketStatuses.push(paketStatus);
    this.maklerPaketStatusEventEmitter.emit(paketStatus);
    console.log("showDetail after" + this.paketStatuses[0]);
  }
  //
  // downloadCSV(toPackage: MaklerPaket) {
  //   this.csvService.getCSVData().subscribe(
  //     (processes) => this.exportCSV(processes)
  //   );
  // }
  //
  // private exportCSV(fromProcesses: Lieferung[]) {
  //   let fileName = "Paket.csv";
  //   let data = fromProcesses;
  //   let keys : string[] = ['id', 'geschaeftsvorgang', 'fremdOM', 'vertragsNR', 'status'];
  //   this.csvExport.downloadCSV({filename: fileName, data: data, keys: keys});
  // }
}

